import React from 'react';
import { knownTrajectoryColors } from '../../utils/trajectoryColor';
import { Conditions } from '../../types/types';

interface TrajectoryInfoPanelProps {
  color: string;
  length: number;
  conditions: Conditions;
  onClose: () => void;
}

const TrajectoryInfoPanel: React.FC<TrajectoryInfoPanelProps> = ({
  color,
  length,
  conditions,
  onClose,
}) => {
  const formattedConditions = Object.entries(conditions).map(
    ([key, value]) => ({
      name: key.charAt(0).toUpperCase() + key.slice(1),
      value: value ? 'Yes' : 'No',
    })
  );

  return (
    <div className="absolute top-4 right-4 w-72 bg-white dark:bg-neutral-900 text-black dark:text-white p-4 rounded-lg shadow-lg border border-gray-300 dark:border-gray-700">
      <div className="flex items-center space-x-3 mb-2">
        <span
          className="w-6 h-6 rounded-full"
          style={{
            backgroundColor:
              color in knownTrajectoryColors
                ? knownTrajectoryColors[
                    color as keyof typeof knownTrajectoryColors
                  ]
                : 'gray',
          }}
          aria-label={`${color} color`}
        />
        <h4 className="text-lg font-semibold capitalize">{color} Trajectory</h4>
      </div>
      <p className="text-sm mb-1">
        <strong>Length:</strong> {length} m
      </p>
      <div className="text-sm">
        <strong>Conditions:</strong>
        <ul className="ml-4 list-disc">
          {formattedConditions.map((cond) => (
            <li key={cond.name}>
              {cond.name}:{' '}
              <span
                className={
                  cond.value === 'Yes'
                    ? 'text-green-600 font-semibold'
                    : 'text-gray-500'
                }
              >
                {cond.value}
              </span>
            </li>
          ))}
        </ul>
      </div>
      <button
        onClick={onClose}
        className="mt-4 px-3 py-1 text-sm bg-red-500 text-white rounded hover:bg-red-600"
      >
        Close
      </button>
    </div>
  );
};

export default TrajectoryInfoPanel;
